/**
 * Slider 5 images vedettes éditable via CRM admin.
 *
 * Wrap le composant existant SliderSection avec le variant brixsa-parallax
 * (l'animation utilisée pour les 7 images du Lieu) — zéro nouveau code
 * d'animation, juste copie de structure de slides à partir du remote DB.
 *
 * Render null si pas d'images remote (silent fallback : la section n'apparaît
 * pas tant que l'admin n'a pas configuré les 5 images).
 *
 * Chaque slide reçoit linkHref="#galerie-highlight-{i}" : au clic, le slide
 * agit comme un anchor capté par le listener global de EventGallery, qui
 * ouvre le modal sur la section "Highlights" à l'index i. Cf. galleryShape.ts
 * pour la section virtuelle, EventGallery.tsx pour le listener.
 */

import type { SectionConfig } from '@/types/site'
import type { EventSiteSliderShape } from '@/lib/siteSliderShape'
import { SliderSection } from '@/components/sections'

interface EventSiteSliderProps {
  images: EventSiteSliderShape
}

export default function EventSiteSlider({ images }: EventSiteSliderProps) {
  /* Skip silencieux si pas d'images : la section n'apparaît pas du tout. */
  if (!images || images.length === 0) return null

  const config: SectionConfig = {
    id: 'event-site-slider',
    type: 'slider',
    variant: 'brixsa-parallax',
    content: {
      title: '',
      slides: images.map((img, i) => ({
        id: img.id || String(i + 1),
        title: img.title ?? '',
        subtitle: img.subtitle ?? '',
        badge: img.badge ?? '',
        image: img.url,
        linkHref: `#galerie-highlight-${i}`,
      })),
    },
    style: { background: 'dark', paddingY: 'none' },
    visible: true,
  }

  return <SliderSection config={config} />
}
